import { render, staticRenderFns } from "./whats_new_for_you_menu_item.vue.js?vue&type=template&id=0d7b2e36&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./whats_new_for_you_menu_item.vue?vue&type=template&id=0d7b2e36&vue3"
import script from "./whats_new_for_you_menu_item.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./whats_new_for_you_menu_item.vue?vue&type=script&lang=js&vue3"
export * from "./whats_new_for_you_menu_item.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./whats_new_for_you_menu_item.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports